import './rewardPreview.scss'
import { useLocal } from '@/i18n/LocalContext'
import CommonModal from '../CommonModal/CommonModal'
import { useStore } from '@/store'
import Prop from '../Prop/Prop'
import { getRewards } from '@/request'
import { useEffect, useRef, useState } from 'react'

export default function RewardPreview() {
  const { $t } = useLocal()
  const { state } = useStore()
  const playerId = state.login.userInfo.playerId
  const rewardOpen = state.modalData.rewardOpen
  const [data, setData] = useState<Awaited<ReturnType<typeof getRewards>>>(null)
  const pending = useRef(false)

  useEffect(() => {
    if (!playerId || !rewardOpen) return

    if (pending.current) return

    pending.current = true
    const _run = async () => {
      const res = await getRewards(playerId)
      setData(res)
    }
    _run()
    pending.current = false
    
  }, [playerId, rewardOpen])

  const getPropListByLevel = (level: keyof typeof data) => {
    return (data[level].map((reward, n) => {
      return (<li key={n} className="record-preview-prop">
        <Prop level={parseInt(level.slice(-1)) as CouponLevel} name={reward.name} imgSrc={reward.icon} count={reward.count} get={reward.isWon} desc={reward.desc} />
      </li>)
    }))
  }

  if (data == null) return null
  
  return (
    <CommonModal
      open={rewardOpen} title={$t('奖励预览')} length="long"
      desc={$t('奖励不会重复获得。普通抽奖券有小概率抽到稀有奖励，稀有抽奖券有小概率抽到高级奖励。')}
    >
      {[
        <div key="1" className="record-preview">
          <div className="record-preview-section-title">
            <span>{$t('极品奖池')}</span>
          </div>
          <ul className="record-preview-prop-list">
            {getPropListByLevel('level3')}
          </ul>
          <div className="record-preview-section-title">
            <span>{$t('稀有奖池')}</span>
          </div>
          <ul className="record-preview-prop-list">
            {getPropListByLevel('level2')}
          </ul>
          <div className="record-preview-section-title">
            <span>{$t('普通奖池')}</span>
          </div>
          <ul className="record-preview-prop-list">
            {getPropListByLevel('level1')}
          </ul>
        </div>
      ]}
    </CommonModal>
  )
}